import { useRef } from 'react';

export const useKeepData = <Data>(data: Data, keepPrevious: boolean): Data => {
  const dataStash = useRef<Data>(data);
  if (!keepPrevious) {
    dataStash.current = data;
  }
  return dataStash.current;
};
